<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dialogues">
<div class="section level2" id="crumbles">
<h2>Crumbles</h2>
<table style="width:98%;">
<colgroup>
<col width="7%"/>
<col width="78%"/>
</colgroup>
<thead>
<tr class="header">
<td align="left" colspan="2">M=man W=woman</td>
</tr>
</thead>
<tbody>
<tr class="odd">
<td align="left">W:</td>
<td>What is the matter dear?</td>
</tr>
<tr class="even">
<td align="left">M:</td>
<td>My foot hurts.</td>
</tr>
<tr class="odd">
<td align="left">W:</td>
<td>From what dear?</td>
</tr>
<tr class="even">
<td align="left">M:</td>
<td>I am not sure. But I think it was from yesterday.</td>
</tr>
<tr class="odd">
<td align="left">W:</td>
<td>You should have said something. So what happened?</td>
</tr>
<tr class="even">
<td align="left">M:</td>
<td>The Golden Fumbles cookie truck ran over it.</td>
</tr>
<tr class="odd">
<td align="left">W:</td>
<td>I guess that’s the way your foot under the Fumbles crumbles!</td>
</tr>
</tbody>
</table>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?4f8488e3